import { Prop, Watch, BaseTLDetailComponent, TagService, AxiosResponse, ObjectTypesHelper, TagFilter } from "../../../Infrastructure/CorBase/CoreBase";
import { IReceiverService, ServicesFactory } from "../../../Infrastructure/ServicesFactory";
import tinycolor from 'tinycolor2';
export default abstract class TagDetailBase extends BaseTLDetailComponent {

	@Prop({ type: String, required: false, default: "" }) design?: string; //design - modal

	idModal = 0;
	isAnyEdit = false;

	tagService: TagService = new TagService();
	receiverService: IReceiverService | null = ServicesFactory.getReceiverService();

	isEditDetail = false;
	receivers: any[] = [];

	receiversOld: any = [];
	receiversAll: any = [];

	valueH = 50;
	valueL = 50;
	valueS = 50;
	//@Watch('formData.color')
	//onPropertyDropDownInputChanged3(value: string, oldValue: string) {
	//	if (value !== oldValue) {
	//		var copy = JSON.parse(JSON.stringify(this.formData.color));
	//		const color = tinycolor(this.formData.color);
	//		setTimeout(() => { this.formData.color = this.computedColor(this.formData.color); }, 100);
	//	}
	//}


	public receiverNotChangeBase(): boolean {
		if (this.receivers.length != this.receiversOld.length) {
			return false;
		}
		else {
			for (var i = 0; i < this.receivers.length; i++) {
				if (this.receiversOld.filter((c:any) => c.id == this.receivers[i].id).length == 0) {
					return false;
				}
			}
		}
		return true;
	}

	@Watch('valueH')
	onPropertyValueH(value: string, oldValue: string) {
		if (value !== oldValue) {
			this.prepareColorFromValue();
		}
	}

	@Watch('valueL')
	onPropertyValueL(value: string, oldValue: string) {
		if (value !== oldValue) {
			this.prepareColorFromValue();
		}
	}

	@Watch('valueS')
	onPropertyValueS(value: string, oldValue: string) {
		if (value !== oldValue) {
			this.prepareColorFromValue();
		}
	}

	prepareColorFromValue() {
		const hsl = tinycolor(this.formData.color).toHsl();
		hsl.s = this.valueS ; 
		hsl.l =this.valueL ; // omezí jas na rozmezí 50-70%
		hsl.h = this.valueH; // omezí odstín na rozmezí 0-360
		this.formData.color = tinycolor(hsl).toHexString();
	}

	selectColorBase(item: string) {
		const hsl = tinycolor(item).toHsl();
		this.valueS = Math.round(hsl.s * 100);
		this.valueH = Math.round(hsl.h * 1);
		this.valueL = Math.round(hsl.l * 100);
	}

	loadColorValues(color: any) {
		const hsl = tinycolor(color).toHsl();
		this.valueH = Math.round(hsl.h*1);
		this.valueL = Math.round(hsl.l * 100);
		this.valueS = Math.round(hsl.s * 100);
	}


	//uprava barvy
	//computedColor(color: any) {
	//	const hsl = tinycolor(color).toHsl();
	//	hsl.s = 0.5; // nastaví sytost na 50%
	//	hsl.l = Math.min(Math.max(hsl.l, 0.5), 0.7); // omezí jas na rozmezí 50-70%
	//	hsl.h = Math.min(Math.max(hsl.h, 0), 360); // omezí odstín na rozmezí 0-360
	//	return tinycolor(hsl).toHexString();
	//}

	createdBase() {
	}

	deleteSubDetailBase(item: any) {
		this.isEditDetail = true;
		this.mainDataChangedSub = true;
		this.receivers = (this.receivers as Array<any>).filter(d => d.id != item) as [];
	}

	loadReceivers() {
		if (this.receiverService != null) {
			//TODO dodelat nacitani receiveru
			let filter = ServicesFactory.getReceiverFilter(this.$store.state.idTenant, this.objectIdChild);
			this.isBusy = true;
			this.receiverService.getAllByFilter(filter).then(response => {
				this.receivers = response.data;
				this.receiversOld = [];
				this.receivers.forEach(val => this.receiversOld.push(Object.assign({}, val)));
				this.isBusy = false;
			});
		}
	}

	//load do modalni nabidky
	initAllReceivers(): void {
		let filter = new TagFilter(this.$store.state.idTenant, this.formData.id);
        this.tagService.getAllObjectToTagByFilter(filter).then(response => {
			this.receiversAll = [];
			for (var i = 0; i < response.data.length; i++) {
				if (!this.receivers.some((c:any) => c.id ==  response.data[i].id)) {
					this.receiversAll.push(response.data[i]);
				}
            }
        });

	}

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	addSubDetailBase() {
		this.initAllReceivers();
		this.$bvModal.show('reciverModal');
	}


	setSelected(id: any) {
		this.idModal = id;
		this.loadFormData();
	}

	selectedItemsBase(items: any): void {
		for (var i = 0; i < items.length; i++) {
			if (this.receivers.filter((c: any) => c.id == items[i].id && c.pageDetail == items[i].pageDetail).length == 0) {
				this.isEditDetail = true;
				this.mainDataChangedSub = true;
				this.receivers.push(this.receiversAll.filter((c: any) => c.id == items[i].id && c.pageDetail == items[i].pageDetail )[0]);
			}
		}
	}

	saveDetail(): void {
		this.isBusy = true;
		this.tagService.updateAllObjectTag(this.formData.id, this.receivers).then(response => {

			this.receiversOld = [];
			this.receivers.forEach(val => this.receiversOld.push(Object.assign({}, val)));
			this.isAnyEdit = true;
			this.isBusy = false;
		});

	}

	goBackDetail(): void {
		this.mainDataChangedSub = false;
		this.isEditDetail = false;
		this.receivers = [];
		this.receiversOld.forEach((val: any) => this.receivers.push(Object.assign({}, val)));
	}

	fields = [
		{ key: 'nameType', label: this.$t('tag.fieldTypeObject'), sortable: true, trans: 'tag.fieldTypeObject', class: 'text-center', optional: false, visible: true },
		{ key: 'name', label: this.$t('tag.fieldName'), trans: 'tag.fieldName', sortable: true, class: 'text-center', optional: false, visible: true, design: 'detail' },
		{ key: 'description', label: this.$t('tag.fieldDescription'), trans: 'tag.fieldDescription', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'actions', label: this.$t('content.fieldActions'), trans: 'content.fieldActions', class: 'text-right' }
	];

	fieldsModalTable = [
		{ key: 'nameType', label: this.$t('tag.fieldTypeObject'), trans: this.$t('tag.fieldTypeObject'), sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'name', label: this.$t('tag.fieldName'), sortable: true, trans: this.$t('tag.fieldName'), class: 'text-center', optional: false, visible: true },
		{ key: 'description', label: this.$t('tag.fieldDescription'), trans: this.$t('tag.fieldDescription'), sortable: true, class: 'text-center', optional: false, visible: true },

	];


	filtersModal = [
		{ key: 'nameType', label: this.$t('tag.fieldTypeObject'), trans: this.$t('tag.fieldTypeObject'), selected: false, value: null, type: 'text' },
		{ key: 'name', label: this.$t('tag.fieldName'), trans: this.$t('tag.fieldName'), selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true }
	];

	returnRoute: string = "TagList";
	objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.None;
	formData = {
		id: 0 as number,
		name: '' as string,
		description: '' as string,
		idTenant: this.$store.state.idTenant as number,
		color: '#000000' as string
	};
	idBasePreview = 0;

	goToEdit(): void {
		this.formIsInEditMode = !this.formIsInEditMode;
	}

	modalNameContent(): string {
		return this.$t('tag.modalContentName') +"";
	}

	goBack(): void {
		if (this.idModal > 0) {
			this.$emit('goBack', this.formData);
		}
		else {
			this.$router.push({ name: this.returnRoute });
		}
	}

	loadFormData() {
		if (this.objectIdChild > 0) {
			this.fetchData();
			
		//	this.loadReceivers();
		}
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return this.tagService.getById(this.objectIdChild);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	protected processResponse(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
		this.formData.name = response.data.name;
		this.formData.idTenant = response.data.idTenant;
		this.formData.description = response.data.description;
		this.formData.color = response.data.color;
		this.receivers = response.data.allMediaAssigned;
		for (var i = 0; i < this.receivers.length; i++) {
			this.receivers[i].nameType = this.$t('tag.' + this.receivers[i].nameType);
		}
		this.receiversOld = [];
		this.receivers.forEach(val => this.receiversOld.push(Object.assign({}, val)));
		this.loadColorValues(this.formData.color);
	}

	protected afterCreate(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
	}

	protected afterUpdate(response: AxiosResponse<any>): void {
		this.isAnyEdit = true;
	}

	get objectIdChild(): number {
		if (this.design == 'modal') {
			return this.idModal;
		}
		if (this.idModal > 0) {
			return this.idModal;
		}
		return this.objectId;
	}

	vIsCorrectName: boolean = true;

	validateBase() {
		return !(this.vIsCorrectName);
	}

	isCorrectNameBase(value: any) {
		this.vIsCorrectName = value;
	}

	doAction() {
		if (!this.receiverNotChangeBase()) {
			this.saveDetail();
		}

		if (this.formIsInEditMode || this.styleFormDelete) {
			super.doCRUDActionWithInfoMessage(this.$t('tag.messageNew').toString(), this.$t('tag.messageEdit').toString(), this.$t('tag.messageDelete').toString());
		}
		this.isEditDetail = false;
		this.mainDataChangedSub = false;

	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		return this.tagService.update(this.objectIdChild, this.formData);
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return this.tagService.create(this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return this.tagService.delete(this.objectIdChild);
	}

	//@ts-ignore
	@Watch('$i18n.locale')
	changeLanguageBase(value: boolean, oldValue: boolean) {
		if (value !== oldValue) {
			this.fields = this.changeTranslate(this.fields);
			this.fieldsModalTable = this.changeTranslate(this.fieldsModalTable);
			this.filtersModal = this.changeTranslate(this.filtersModal);
		}
	}
}
